import { ApiSet, BaseResponse, IndexApiSet, useIndexApi, usePatchApi, useShowApi } from 'utils/network/api_hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { Rack } from 'entities/rack'
import { Form } from 'utils/hooks'

type RacksResponse = PagingResponse & {
    results: Rack[]
}

export function useFetchRacksApi(): IndexApiSet<RacksResponse> & {
    execute: (params: { ordering?: string; codeIn?: string; rackType?: string }) => void
} {
    const apiPath = 'racks/'
    const api = useIndexApi<RacksResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
    })

    const execute = (params: { ordering?: string; codeIn?: string; rackType?: string }): void => {
        api.execute(apiPath, { params: params })
    }

    return { ...api, execute: execute }
}

type RackResponse = BaseResponse & Rack

export function useFetchRackApi(): ApiSet<RackResponse> & {
    execute: (id: string) => void
} {
    const api = useShowApi<RackResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (id: string): void => {
        const apiPath = `racks/${id}/`
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}

export type DisposeSampleForm = {
    disposalNote?: string
}

export function useDisposeSamplesApi(): ApiSet<BaseResponse> & {
    execute: (id: number, form: Form<DisposeSampleForm>) => void
} {
    const api = usePatchApi<BaseResponse, DisposeSampleForm>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (id: number, form: Form<DisposeSampleForm>): void => {
        const apiPath = `racks/${id}/dispose/`
        api.execute(apiPath, form.object)
    }

    return { ...api, execute: execute }
}
